$(document).ready(function(){
//   console.log("ready");
//   var inPuthh = "21" ;
//   var users = [
//   { "21": "John", "month": 23},{ "52": "kiran", "year": 23234},{ "33": "ashu", "date": 56767},{ "45": "nitika", "week": 7687}
// ];
//    const myObject = [
//   { "21": "John", "month": 23},{ "52": "kiran", "year": 23234},{ "33": "ashu", "date": 56767},{ "45": "nitika", "week": 7687}
// ];
//   console.log(users[2]);
//   console.log(Object.values(myObject).filter(x => x !== null).length);
//   console.log("next");
//   console.log(Object.keys(myObject)
//   .map(x => myObject[x])
//   .filter(x => x !== null).length);
  var data = {
  "items": [{
    "PLZ": "70794",
    "Stadt": "Filderstadt",
    "Förderung": "150€ pro Haushalt",
    "Zusatzliche": "Filderstadt Balkonkraftwerk Förderwebseite"    
  }, {
    "PLZ": "79098",
    "Stadt": "Freiburg",
    "Förderung": "Bis zu 200 Euro pro Person und Balkonkraftwerk",
    "Zusatzliche": "Freiburg: Förderprogramm Klimafreundlich Wohnen"    
  }, {
    "PLZ": "79099",
    "Stadt": "Freiburg",
    "Förderung": "Bis zu 200 Euro pro Person und Balkonkraftwerk",
    "Zusatzliche": "Freiburg: Förderprogramm Klimafreundlich Wohnen"    
  },{
    "PLZ": "79100",
    "Stadt": "Freiburg",
    "Förderung": "Bis zu 200 Euro pro Person und Balkonkraftwerk",
    "Zusatzliche": "Freiburg: Förderprogramm Klimafreundlich Wohnen"  
  }, {
    "PLZ": "79101",
    "Stadt": "Freiburg",
    "Förderung": "Bis zu 200 Euro pro Person und Balkonkraftwerk",
    "Zusatzliche": "Freiburg: Förderprogramm Klimafreundlich Wohnen"  
  }, {
    "PLZ": "79102",
    "Stadt": "Freiburg",
    "Förderung": "Bis zu 200 Euro pro Person und Balkonkraftwerk",
    "Zusatzliche": "Freiburg: Förderprogramm Klimafreundlich Wohnen"    
  },{
    "PLZ": "79103",
    "Stadt": "Freiburg",
    "Förderung": "Bis zu 200 Euro pro Person und Balkonkraftwerk",
    "Zusatzliche": "Freiburg: Förderprogramm Klimafreundlich Wohnen"    
  }, {
    "PLZ": "79104",
    "Stadt": "Freiburg",
    "Förderung": "Bis zu 200 Euro pro Person und Balkonkraftwerk",
    "Zusatzliche": "Freiburg: Förderprogramm Klimafreundlich Wohnen"    
  }, {
    "PLZ": "79118",
    "Stadt": "Freiburg",
    "Förderung": "Bis zu 200 Euro pro Person und Balkonkraftwerk",
    "Zusatzliche": "Freiburg: Förderprogramm Klimafreundlich Wohnen"   
  },{
    "PLZ": "79106",
    "Stadt": "Freiburg",
    "Förderung": "Bis zu 200 Euro pro Person und Balkonkraftwerk",
    "Zusatzliche": "Freiburg: Förderprogramm Klimafreundlich Wohnen"   
  }, {
    "PLZ": "79189",
    "Stadt": "Freiburg",
    "Förderung": "Bis zu 200 Euro pro Person und Balkonkraftwerk",
    "Zusatzliche": "Freiburg: Förderprogramm Klimafreundlich Wohnen"   
  }, {
    "PLZ": "79108",
    "Stadt": "Freiburg",
    "Förderung": "Bis zu 200 Euro pro Person und Balkonkraftwerk",
    "Zusatzliche": "Freiburg: Förderprogramm Klimafreundlich Wohnen"    
  }, {
    "PLZ": "79110",
    "Stadt": "Freiburg",
    "Förderung": "Bis zu 200 Euro pro Person und Balkonkraftwerk",
    "Zusatzliche": "Freiburg: Förderprogramm Klimafreundlich Wohnen"   
  }, {
    "PLZ": "79111",
    "Stadt": "Freiburg",
    "Förderung": "Bis zu 200 Euro pro Person und Balkonkraftwerk",
    "Zusatzliche": "Freiburg: Förderprogramm Klimafreundlich Wohnen"     
  },{
    "PLZ": "79112",
    "Stadt": "Freiburg",
    "Förderung": "Bis zu 200 Euro pro Person und Balkonkraftwerk",
    "Zusatzliche": "Freiburg: Förderprogramm Klimafreundlich Wohnen"     
  }, {
    "PLZ": "79114",
    "Stadt": "Freiburg",
    "Förderung": "Bis zu 200 Euro pro Person und Balkonkraftwerk",
    "Zusatzliche": "Freiburg: Förderprogramm Klimafreundlich Wohnen"     
  },{
    "PLZ": "79115",
    "Stadt": "Freiburg",
    "Förderung": "Bis zu 200 Euro pro Person und Balkonkraftwerk",
    "Zusatzliche": "Freiburg: Förderprogramm Klimafreundlich Wohnen"    
  }, {
    "PLZ": "79117",
    "Stadt": "Freiburg",
    "Förderung": "Bis zu 200 Euro pro Person und Balkonkraftwerk",
    "Zusatzliche": "Freiburg: Förderprogramm Klimafreundlich Wohnen"   
  }, {
    "PLZ": "88045",
    "Stadt": "Friedrichshafen",
    "Förderung": "300 Euro pro Haushalt (mind. 300 Watt Anlage erforderlich)",
    "Zusatzliche": "Friedrichshafen: Förderprogramm Klimaschutz"    
  },{
    "PLZ": "88046",
    "Stadt": "Friedrichshafen",
    "Förderung": "300 Euro pro Haushalt (mind. 300 Watt Anlage erforderlich)",
    "Zusatzliche": "Friedrichshafen: Förderprogramm Klimaschutz"   
  }, {
    "PLZ": "88048",
    "Stadt": "Friedrichshafen",
    "Förderung": "300 Euro pro Haushalt (mind. 300 Watt Anlage erforderlich)",
    "Zusatzliche": "Friedrichshafen: Förderprogramm Klimaschutz"    
  }, {
    "PLZ": "88069",
    "Stadt": "Friedrichshafen",
    "Förderung": "300 Euro pro Haushalt (mind. 300 Watt Anlage erforderlich)",
    "Zusatzliche": "Friedrichshafen: Förderprogramm Klimaschutz"    
  },{
    "PLZ": "71292",
    "Stadt": "Friolzheim",
    "Förderung": "100 Euro pro Mini-PV Anlage",
    "Zusatzliche": "Friolzheim: Balkonkraftwerk Förderrichtlinien"    
  }, {
    "PLZ": "68542",
    "Stadt": "Heddesheim",
    "Förderung": "100 Euro pro Modul (max. 2)",
    "Zusatzliche": "Heddesheim: Umweltförderprogramm"    
  }, {
    "PLZ": "69115",
    "Stadt": "Heidelberg",
    "Förderung": "50% der Anschaffungskosten (max. 750 Euro), Heidelberg-Pass Besitzer bis zu 1.450 Euro bei einem Eigenanteil von 50 Euro",
    "Zusatzliche": "Heidelberg: Förderbaustein PV-Anlagen"    
  },{
    "PLZ": "69117",
    "Stadt": "Heidelberg",
    "Förderung": "50% der Anschaffungskosten (max. 750 Euro), Heidelberg-Pass Besitzer bis zu 1.450 Euro bei einem Eigenanteil von 50 Euro",
    "Zusatzliche": "Heidelberg: Förderbaustein PV-Anlagen"    
  }, {
    "PLZ": "69118",
    "Stadt": "Heidelberg",
    "Förderung": "50% der Anschaffungskosten (max. 750 Euro), Heidelberg-Pass Besitzer bis zu 1.450 Euro bei einem Eigenanteil von 50 Euro",
    "Zusatzliche": "Heidelberg: Förderbaustein PV-Anlagen"    
  }, {
    "PLZ": "69120",
    "Stadt": "Heidelberg",
    "Förderung": "50% der Anschaffungskosten (max. 750 Euro), Heidelberg-Pass Besitzer bis zu 1.450 Euro bei einem Eigenanteil von 50 Euro",
    "Zusatzliche": "Heidelberg: Förderbaustein PV-Anlagen"    
  },{
    "PLZ": "69121",
    "Stadt": "Heidelberg",
    "Förderung": "50% der Anschaffungskosten (max. 750 Euro), Heidelberg-Pass Besitzer bis zu 1.450 Euro bei einem Eigenanteil von 50 Euro",
    "Zusatzliche": "Heidelberg: Förderbaustein PV-Anlagen"    
  }, {
    "PLZ": "69123",
    "Stadt": "Heidelberg",
    "Förderung": "50% der Anschaffungskosten (max. 750 Euro), Heidelberg-Pass Besitzer bis zu 1.450 Euro bei einem Eigenanteil von 50 Euro",
    "Zusatzliche": "Heidelberg: Förderbaustein PV-Anlagen"    
  }, {
    "PLZ": "69124",
    "Stadt": "Heidelberg",
    "Förderung": "50% der Anschaffungskosten (max. 750 Euro), Heidelberg-Pass Besitzer bis zu 1.450 Euro bei einem Eigenanteil von 50 Euro",
    "Zusatzliche": "Heidelberg: Förderbaustein PV-Anlagen"   
  },{
    "PLZ": "69126",
    "Stadt": "Heidelberg",
    "Förderung": "50% der Anschaffungskosten (max. 750 Euro), Heidelberg-Pass Besitzer bis zu 1.450 Euro bei einem Eigenanteil von 50 Euro",
    "Zusatzliche": "Heidelberg: Förderbaustein PV-Anlagen"   
  }, {
    "PLZ": "69151",
    "Stadt": "Heidelberg",
    "Förderung": "50% der Anschaffungskosten (max. 750 Euro), Heidelberg-Pass Besitzer bis zu 1.450 Euro bei einem Eigenanteil von 50 Euro",
    "Zusatzliche": "Heidelberg: Förderbaustein PV-Anlagen"    
  }, {
    "PLZ": "77694",
    "Stadt": "Kehl",
    "Förderung": "200 Euro, sozial schwache Antragsteller (t. B. Tafelkunden oder Personen mit Wohngeldbescheid) 300 Euro",
    "Zusatzliche": "Kehl: Förderprogramm Klimafreundlich Leben"    
  },{
    "PLZ": "70806",
    "Stadt": "Kornwestheim",
    "Förderung": "200 Euro pro Haushalt (bis max. 600 Watt)",
    "Zusatzliche": "Kornwestheim Förderprogramm „Wir stärken Klima“"    
  }, {
    "PLZ": "79539",
    "Stadt": "Lörrach",
    "Förderung": "200 Euro pro Haushalt (bis max. 600 Watt)",
    "Zusatzliche": "Lörrach: Balkonsolar Förderrichtlinien"    
  }, {
    "PLZ": "79540",
    "Stadt": "Lörrach",
    "Förderung": "200 Euro pro Haushalt (bis max. 600 Watt)",
    "Zusatzliche": "Lörrach: Balkonsolar Förderrichtlinien"     
  },{
    "PLZ": "79541",
    "Stadt": "Lörrach",
    "Förderung": "200 Euro pro Haushalt (bis max. 600 Watt)",
    "Zusatzliche": "Lörrach: Balkonsolar Förderrichtlinien"    
  }, {
    "PLZ": "71634",
    "Stadt": "Ludwigsburg",
    "Förderung": "300 Euro, für BezieherInnen der Ludwigsburg Card bis zu 800 Euro",
    "Zusatzliche": "Ludwigsburg: Klimaschutz Förderprogramm"    
  }, {
    "PLZ": "71636",
    "Stadt": "Ludwigsburg",
    "Förderung": "300 Euro, für BezieherInnen der Ludwigsburg Card bis zu 800 Euro",
    "Zusatzliche": "Ludwigsburg: Klimaschutz Förderprogramm"     
  },{
    "PLZ": "71638",
    "Stadt": "Ludwigsburg",
    "Förderung": "300 Euro, für BezieherInnen der Ludwigsburg Card bis zu 800 Euro",
    "Zusatzliche": "Ludwigsburg: Klimaschutz Förderprogramm"     
  }, {
    "PLZ": "75387",
    "Stadt": "Neubulach",
    "Förderung": "50 pro Modul bzw. 100 Euro",
    "Zusatzliche": "Neubulach: Mini-PV-Anlagen Förderprogramm"    
  }, {
    "PLZ": "74248",
    "Stadt": "Schwaigheim",
    "Förderung": "200 Euro pro Haushalt",
    "Zusatzliche": "Schwaighaim: Mini-PV-Förderung"    
  },{
    "PLZ": "68723",
    "Stadt": "Schwetzingen",
    "Förderung": "einmalig mit maximal 300 Euro, höchstens jedoch 30% der Anschaffungskosten",
    "Zusatzliche": "Schwetzingen: KlimaIMPULS-Programm"    
  }, {
    "PLZ": "70173",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"    
  }, {
    "PLZ": "70174",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"     
  },{
    "PLZ": "70176",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"     
  }, {
    "PLZ": "70178",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"      
  }, {
    "PLZ": "70180",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"    
  },{
    "PLZ": "70182",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"    
  }, {
    "PLZ": "70184",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"   
  }, {
    "PLZ": "70186",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"    
  },{
    "PLZ": "70188",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"     
  }, {
    "PLZ": "70190",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"  
  }, {
    "PLZ": "70191",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"     
  },{
    "PLZ": "70192",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"  
  }, {
    "PLZ": "70193",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"    
  }, {
    "PLZ": "70195",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"     
  },{
    "PLZ": "70197",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"   
  }, {
    "PLZ": "70199",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"    
  }, {
    "PLZ": "70327",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"     
  },{
    "PLZ": "70329",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"     
  }, {
    "PLZ": "70372",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"    
  }, {
    "PLZ": "70374",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"    
  },{
    "PLZ": "70376",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"    
  }, {
    "PLZ": "70378",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"    
  }, {
    "PLZ": "70435",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"     
  },{
    "PLZ": "70437",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"  
  }, {
    "PLZ": "70439",
    "Stadt": "Stuttgart",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Stuttgart: Solaroffensive"    
  }, {
    "PLZ": "89073",
    "Stadt": "Ulm",
    "Förderung": "50% bis zu 250 Euro pro Haushalt",
    "Zusatzliche": "Ulm: Energieförderprogramm"    
  },{
    "PLZ": "89075",
    "Stadt": "Ulm",
    "Förderung": "50% bis zu 250 Euro pro Haushalt",
    "Zusatzliche": "Ulm: Energieförderprogramm"      
  }, {
    "PLZ": "89077",
    "Stadt": "Ulm",
    "Förderung": "50% bis zu 250 Euro pro Haushalt",
    "Zusatzliche": "Ulm: Energieförderprogramm"       
  }, {
    "PLZ": "89079",
    "Stadt": "Ulm",
    "Förderung": "50% bis zu 250 Euro pro Haushalt",
    "Zusatzliche": "Ulm: Energieförderprogramm"       
  },{
    "PLZ": "89081",
    "Stadt": "Ulm",
    "Förderung": "50% bis zu 250 Euro pro Haushalt",
    "Zusatzliche": "Ulm: Energieförderprogramm"       
  }, {
    "PLZ": "89083",
    "Stadt": "Ulm",
    "Förderung": "50% bis zu 250 Euro pro Haushalt",
    "Zusatzliche": "Ulm: Energieförderprogramm"      
  }, {
    "PLZ": "89085",
    "Stadt": "Ulm",
    "Förderung": "50% bis zu 250 Euro pro Haushalt",
    "Zusatzliche": "Ulm: Energieförderprogramm"      
  },{
    "PLZ": "89087",
    "Stadt": "Ulm",
    "Förderung": "50% bis zu 250 Euro pro Haushalt",
    "Zusatzliche": "Ulm: Energieförderprogramm"    
  }, {
    "PLZ": "89089",
    "Stadt": "Ulm",
    "Förderung": "50% bis zu 250 Euro pro Haushalt",
    "Zusatzliche": "Ulm: Energieförderprogramm"    
  }, {
    "PLZ": "69190",
    "Stadt": "Walldorf",
    "Förderung": "300 Euro, maximal 50 % der anrechenbaren Kosten",
    "Zusatzliche": "Walldorf: Umwelt-Förderprogramme"    
  },{
    "PLZ": "69469",
    "Stadt": "Weinheim",
    "Förderung": "50 Euro pro Solarpanel (max. 2)",
    "Zusatzliche": "Weinheim: Klimaschutz-Förderprogramme"    
  }, {
    "PLZ": "69481",
    "Stadt": "Weinheim",
    "Förderung": "50 Euro pro Solarpanel (max. 2)",
    "Zusatzliche": "Weinheim: Klimaschutz-Förderprogramme"     
  }, {
    "PLZ": "91054",
    "Stadt": "Buckenhof",
    "Förderung": "50 Euro pro 100 Watt-Peak, max. 200 Euro",
    "Zusatzliche": "Buckenhof: Förderrichtlinie"    
  },{
    "PLZ": "86911",
    "Stadt": "Diessen",
    "Förderung": "100 Euro pro Haushalt",
    "Zusatzliche": "Diessen: Förderinfoseite"    
  }, {
    "PLZ": "91052",
    "Stadt": "Erlangen",
    "Förderung": "50 Euro pro 100 Watt-Peak, max. 300 Euro",
    "Zusatzliche": "Erlangen: Förderrichtlinie"    
  }, {
    "PLZ": "91054",
    "Stadt": "Erlangen",
    "Förderung": "50 Euro pro 100 Watt-Peak, max. 300 Euro",
    "Zusatzliche": "Erlangen: Förderrichtlinie"     
  },{
    "PLZ": "91056",
    "Stadt": "Erlangen",
    "Förderung": "50 Euro pro 100 Watt-Peak, max. 300 Euro",
    "Zusatzliche": "Erlangen: Förderrichtlinie"    
  }, {
    "PLZ": "91058",
    "Stadt": "Erlangen",
    "Förderung": "50 Euro pro 100 Watt-Peak, max. 300 Euro",
    "Zusatzliche": "Erlangen: Förderrichtlinie"     
  }, {
    "PLZ": "91301",
    "Stadt": "Forchheim",
    "Förderung": "100 Euro (brutto) je angefangene kWp, max. 400 Euro (brutto) je Gebäude/Wohneinheit bis zu 3,9 kWp",
    "Zusatzliche": "100 Euro (brutto) je angefangene kWp, max. 400 Euro (brutto) je Gebäude/Wohneinheit bis zu 3,9 kWp"    
  },{
    "PLZ": "91320",
    "Stadt": "Forchheim",
    "Förderung": "100 Euro (brutto) je angefangene kWp, max. 400 Euro (brutto) je Gebäude/Wohneinheit bis zu 3,9 kWp",
    "Zusatzliche": "100 Euro (brutto) je angefangene kWp, max. 400 Euro (brutto) je Gebäude/Wohneinheit bis zu 3,9 kWp"    
  }, {
    "PLZ": "91322",
    "Stadt": "Forchheim",
    "Förderung": "100 Euro (brutto) je angefangene kWp, max. 400 Euro (brutto) je Gebäude/Wohneinheit bis zu 3,9 kWp",
    "Zusatzliche": "100 Euro (brutto) je angefangene kWp, max. 400 Euro (brutto) je Gebäude/Wohneinheit bis zu 3,9 kWp"    
  }, {
    "PLZ": "90762",
    "Stadt": "Fürth",
    "Förderung": "110 Euro Zweirichtungszähler-Einrichtung + 50 Euro pro Balkonkraftwerk (beides nur für infra Stromkunden beantragbar)",
    "Zusatzliche": "Fürth: Klimaoffensive"    
  },{
    "PLZ": "90763",
    "Stadt": "Fürth",
    "Förderung": "110 Euro Zweirichtungszähler-Einrichtung + 50 Euro pro Balkonkraftwerk (beides nur für infra Stromkunden beantragbar)",
    "Zusatzliche": "Fürth: Klimaoffensive"   
  }, {
    "PLZ": "90765",
    "Stadt": "Fürth",
    "Förderung": "110 Euro Zweirichtungszähler-Einrichtung + 50 Euro pro Balkonkraftwerk (beides nur für infra Stromkunden beantragbar)",
    "Zusatzliche": "Fürth: Klimaoffensive"    
  }, {
    "PLZ": "90766",
    "Stadt": "Fürth",
    "Förderung": "110 Euro Zweirichtungszähler-Einrichtung + 50 Euro pro Balkonkraftwerk (beides nur für infra Stromkunden beantragbar)",
    "Zusatzliche": "Fürth: Klimaoffensive"    
  },{
    "PLZ": "90768",
    "Stadt": "Fürth",
    "Förderung": "110 Euro Zweirichtungszähler-Einrichtung + 50 Euro pro Balkonkraftwerk (beides nur für infra Stromkunden beantragbar)",
    "Zusatzliche": "Fürth: Klimaoffensive"    
  }, {
    "PLZ": "90769",
    "Stadt": "Fürth",
    "Förderung": "110 Euro Zweirichtungszähler-Einrichtung + 50 Euro pro Balkonkraftwerk (beides nur für infra Stromkunden beantragbar)",
    "Zusatzliche": "Fürth: Klimaoffensive"     
  }, {
    "PLZ": "91091",
    "Stadt": "Großenseebach",
    "Förderung": "50 Euro je Wohneinheit",
    "Zusatzliche": "Großenseebach Richtlinien für private Wohngebäude"    
  }, {
    "PLZ": "89312",
    "Stadt": "Günzburg",
    "Förderung": "100 Euro pro Anlage",
    "Zusatzliche": "Günzburg: Förderrichtlinie"    
  }, {
    "PLZ": "91315",
    "Stadt": "Höchstadt",
    "Förderung": "50 Euro pro Anlage und Haushalt",
    "Zusatzliche": "Höchstadt: Förderrichtlinien"    
  }, {
    "PLZ": "85049",
    "Stadt": "Ingolstadt",
    "Förderung": "200 Euro pro Anlage ( bei mind. 300 Watt)",
    "Zusatzliche": "Ingoldstadt: Infoseite"    
  }, {
    "PLZ": "85051",
    "Stadt": "Ingolstadt",
    "Förderung": "200 Euro pro Anlage ( bei mind. 300 Watt)",
    "Zusatzliche": "Ingoldstadt: Infoseite"    
  }, {
    "PLZ": "85053",
    "Stadt": "Ingolstadt",
    "Förderung": "200 Euro pro Anlage ( bei mind. 300 Watt)",
    "Zusatzliche": "Ingoldstadt: Infoseite"    
  }, {
    "PLZ": "85055",
    "Stadt": "Ingolstadt",
    "Förderung": "200 Euro pro Anlage ( bei mind. 300 Watt)",
    "Zusatzliche": "Ingoldstadt: Infoseite"   
  }, {
    "PLZ": "85057",
    "Stadt": "Ingolstadt",
    "Förderung": "200 Euro pro Anlage ( bei mind. 300 Watt)",
    "Zusatzliche": "Ingoldstadt: Infoseite"    
  }, {
    "PLZ": "91080",
    "Stadt": "Marloffstein",
    "Förderung": "50 Euro pro 100 Wp /max. 200 Euro pro Antragssteller/in",
    "Zusatzliche": "Marloffstein: PV-Förderrichtlinie"    
  }, {
    "PLZ": "80331",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"    
  }, {
    "PLZ": "80333",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "80335",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"  
  }, {
    "PLZ": "80336",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"   
  }, {
    "PLZ": "80337",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude" 
  }, {
    "PLZ": "80339",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"   
  }, {
    "PLZ": "80469",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"  
  }, {
    "PLZ": "80538",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "80539",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude" 
  }, {
    "PLZ": "80634",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "80636",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"   
  }, {
    "PLZ": "80637",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "80638",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"   
  }, {
    "PLZ": "80639",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"  
  }, {
    "PLZ": "80686",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"  
  }, {
    "PLZ": "80687",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"  
  }, {
    "PLZ": "80689",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"   
  }, {
    "PLZ": "80796",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "80797",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"  
  }, {
    "PLZ": "80798",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"   
  }, {
    "PLZ": "80799",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude" 
  }, {
    "PLZ": "80801",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "80802",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"   
  }, {
    "PLZ": "80803",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude" 
  }, {
    "PLZ": "80804",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"  
  }, {
    "PLZ": "80805",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude" 
  }, {
    "PLZ": "80807",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "80809",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude" 
  }, {
    "PLZ": "80933",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude" 
  }, {
    "PLZ": "80935",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"   
  }, {
    "PLZ": "80937",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude" 
  }, {
    "PLZ": "80939",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "80992",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "80993",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude" 
  }, {
    "PLZ": "80995",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "80997",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude" 
  }, {
    "PLZ": "80999",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"   
  }, {
    "PLZ": "81241",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude" 
  }, {
    "PLZ": "81243",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"  
  }, {
    "PLZ": "81245",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "81247",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"  
  }, {
    "PLZ": "81249",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude" 
  }, {
    "PLZ": "81369",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "81371",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "81373",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude" 
  }, {
    "PLZ": "81375",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "81377",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"  
  }, {
    "PLZ": "81379",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "81475",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"    
  }, {
    "PLZ": "81476",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "81477",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"   
  }, {
    "PLZ": "81479",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude" 
  }, {
    "PLZ": "81539",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "81541",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "81543",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "81545",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "81547",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "81549",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "81667",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"  
  }, {
    "PLZ": "81669",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"  
  }, {
    "PLZ": "81671",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "81673",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"   
  }, {
    "PLZ": "81675",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"  
  }, {
    "PLZ": "81677",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "81679",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude" 
  }, {
    "PLZ": "81735",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "81737",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude" 
  }, {
    "PLZ": "81739",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "81825",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"
  }, {
    "PLZ": "81827",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"  
  }, {
    "PLZ": "81829",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"  
  }, {
    "PLZ": "81925",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"   
  }, {
    "PLZ": "81927",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"   
  }, {
    "PLZ": "81929",
    "Stadt": "München",
    "Förderung": "0,4 Euro je Wp, bis 600 Wp je Wohneinheit, jedoch maximal 50% der Investitionskosten",
    "Zusatzliche": "Münchner Förderprogramm Klimaneutrale Gebäude"   
  }, {
    "PLZ": "85368",
    "Stadt": "Moosburg",
    "Förderung": "50% der Nettoanschaffungskosten, max. 200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Moosburg: Solarstrom Förderprogramm"    
  }, {
    "PLZ": "86971",
    "Stadt": "Peiting",
    "Förderung": "120 Euro pro Anlage und Haushalt",
    "Zusatzliche": "Peiting: Stecker-Solaranlagen Förderung"    
  }, {
    "PLZ": "91080",
    "Stadt": "Spardorf",
    "Förderung": "50 Euro pro 100 Watt-Peak, max. 200 Euro",
    "Zusatzliche": "Spardorf: Umwelt-Richtlinie"    
  }, {
    "PLZ": "85716",
    "Stadt": "Unterschleißheim",
    "Förderung": "25% der Anschaffungskosten, max. 200 Euro",
    "Zusatzliche": "Unterschleißheim: Förderprogramm"    
  }, {
    "PLZ": "92249",
    "Stadt": "Vilseck",
    "Förderung": "100 Euro für 300 Watt Anlagen, 150 Euro für 600 Watt Balkonkraftwerke",
    "Zusatzliche": "Vilseck Balkon PV-Anlagen Förderung"    
  }, {
    "PLZ": "82362",
    "Stadt": "Weilheim in Oberbayern",
    "Förderung": "25% der Brutto-Anschaffungskosten, max. 200 Euro",
    "Zusatzliche": ""    
  }, {
    "PLZ": "64283",
    "Stadt": "Darmstadt",
    "Förderung": "200 Euro für ein 300 Watt oder 400 Euro für 600 W Anlagen, jedoch max. nur 50% der Anschaffungs- und Installationskosten",
    "Zusatzliche": ""    
  }, {
    "PLZ": "64285",
    "Stadt": "Darmstadt",
    "Förderung": "200 Euro für ein 300 Watt oder 400 Euro für 600 W Anlagen, jedoch max. nur 50% der Anschaffungs- und Installationskosten",
    "Zusatzliche": ""   
  }, {
    "PLZ": "64287",
    "Stadt": "Darmstadt",
    "Förderung": "200 Euro für ein 300 Watt oder 400 Euro für 600 W Anlagen, jedoch max. nur 50% der Anschaffungs- und Installationskosten",
    "Zusatzliche": ""   
  }, {
    "PLZ": "64289",
    "Stadt": "Darmstadt",
    "Förderung": "200 Euro für ein 300 Watt oder 400 Euro für 600 W Anlagen, jedoch max. nur 50% der Anschaffungs- und Installationskosten",
    "Zusatzliche": "" 
  }, {
    "PLZ": "64291",
    "Stadt": "Darmstadt",
    "Förderung": "200 Euro für ein 300 Watt oder 400 Euro für 600 W Anlagen, jedoch max. nur 50% der Anschaffungs- und Installationskosten",
    "Zusatzliche": ""   
  }, {
    "PLZ": "64293",
    "Stadt": "Darmstadt",
    "Förderung": "200 Euro für ein 300 Watt oder 400 Euro für 600 W Anlagen, jedoch max. nur 50% der Anschaffungs- und Installationskosten",
    "Zusatzliche": ""    
  }, {
    "PLZ": "64295",
    "Stadt": "Darmstadt",
    "Förderung": "200 Euro für ein 300 Watt oder 400 Euro für 600 W Anlagen, jedoch max. nur 50% der Anschaffungs- und Installationskosten",
    "Zusatzliche": ""  
  }, {
    "PLZ": "64297",
    "Stadt": "Darmstadt",
    "Förderung": "200 Euro für ein 300 Watt oder 400 Euro für 600 W Anlagen, jedoch max. nur 50% der Anschaffungs- und Installationskosten",
    "Zusatzliche": ""    
  }, {
    "PLZ": "64299",
    "Stadt": "Darmstadt",
    "Förderung": "200 Euro für ein 300 Watt oder 400 Euro für 600 W Anlagen, jedoch max. nur 50% der Anschaffungs- und Installationskosten",
    "Zusatzliche": ""  
  }, {
    "PLZ": "65719",
    "Stadt": "Main-Taunus-Kreis",
    "Förderung": "100 Euro pauschal pro Wohnung",
    "Zusatzliche": ""    
  }, {
    "PLZ": "65760",
    "Stadt": "Main-Taunus-Kreis",
    "Förderung": "100 Euro pauschal pro Wohnung",
    "Zusatzliche": ""    
  }, {
    "PLZ": "65779",
    "Stadt": "Main-Taunus-Kreis",
    "Förderung": "100 Euro pauschal pro Wohnung",
    "Zusatzliche": ""    
  }, {
    "PLZ": "65812",
    "Stadt": "Main-Taunus-Kreis",
    "Förderung": "100 Euro pauschal pro Wohnung",
    "Zusatzliche": ""    
  }, {
    "PLZ": "65817",
    "Stadt": "Main-Taunus-Kreis",
    "Förderung": "100 Euro pauschal pro Wohnung",
    "Zusatzliche": ""  
  }, {
    "PLZ": "65824",
    "Stadt": "Main-Taunus-Kreis",
    "Förderung": "100 Euro pauschal pro Wohnung",
    "Zusatzliche": ""   
  }, {
    "PLZ": "65830",
    "Stadt": "Main-Taunus-Kreis",
    "Förderung": "100 Euro pauschal pro Wohnung",
    "Zusatzliche": ""  
  }, {
    "PLZ": "65835",
    "Stadt": "Main-Taunus-Kreis",
    "Förderung": "100 Euro pauschal pro Wohnung",
    "Zusatzliche": ""   
  }, {
    "PLZ": "65843",
     "Stadt": "Main-Taunus-Kreis",
    "Förderung": "100 Euro pauschal pro Wohnung",
    "Zusatzliche": ""   
  }, {
    "PLZ": "65879",
    "Stadt": "Main-Taunus-Kreis",
    "Förderung": "100 Euro pauschal pro Wohnung",
    "Zusatzliche": "" 
  }, {
    "PLZ": "64546",
    "Stadt": "Mörfelden-Walldorf",
    "Förderung": "1000 Euro pro Modul (max. 2)",
    "Zusatzliche": ""    
  }, {
    "PLZ": "65183",
    "Stadt": "Wiesbaden",
    "Förderung": "Anlagen bis 3,0 kW pauschal 300 Euro Anlagen bis 6,0 kW pauschal 400 Euro",
    "Zusatzliche": ""    
  }, {
    "PLZ": "65185",
    "Stadt": "Wiesbaden",
    "Förderung": "Anlagen bis 3,0 kW pauschal 300 Euro Anlagen bis 6,0 kW pauschal 400 Euro",
    "Zusatzliche": ""    
  }, {
    "PLZ": "65187",
    "Stadt": "Wiesbaden",
    "Förderung": "Anlagen bis 3,0 kW pauschal 300 Euro Anlagen bis 6,0 kW pauschal 400 Euro",
    "Zusatzliche": ""   
  }, {
    "PLZ": "65189",
    "Stadt": "Wiesbaden",
    "Förderung": "Anlagen bis 3,0 kW pauschal 300 Euro Anlagen bis 6,0 kW pauschal 400 Euro",
    "Zusatzliche": ""     
  }, {
    "PLZ": "65191",
    "Stadt": "Wiesbaden",
    "Förderung": "Anlagen bis 3,0 kW pauschal 300 Euro Anlagen bis 6,0 kW pauschal 400 Euro",
    "Zusatzliche": ""     
  }, {
    "PLZ": "65193",
    "Stadt": "Wiesbaden",
    "Förderung": "Anlagen bis 3,0 kW pauschal 300 Euro Anlagen bis 6,0 kW pauschal 400 Euro",
    "Zusatzliche": ""    
  }, {
    "PLZ": "65195",
    "Stadt": "Wiesbaden",
    "Förderung": "Anlagen bis 3,0 kW pauschal 300 Euro Anlagen bis 6,0 kW pauschal 400 Euro",
    "Zusatzliche": "" 
  }, {
    "PLZ": "65197",
    "Stadt": "Wiesbaden",
    "Förderung": "Anlagen bis 3,0 kW pauschal 300 Euro Anlagen bis 6,0 kW pauschal 400 Euro",
    "Zusatzliche": ""    
  }, {
    "PLZ": "65199",
    "Stadt": "Wiesbaden",
    "Förderung": "Anlagen bis 3,0 kW pauschal 300 Euro Anlagen bis 6,0 kW pauschal 400 Euro",
    "Zusatzliche": ""   
  }, {
    "PLZ": "37073",
    "Stadt": "Göttingen",
    "Förderung": "180 Euro pauschal pro Anlage",
    "Zusatzliche": "KlimaFonds der Stadt Göttingen"    
  }, {
    "PLZ": "37075",
    "Stadt": "Göttingen",
    "Förderung": "180 Euro pauschal pro Anlage",
    "Zusatzliche": "KlimaFonds der Stadt Göttingen"     
  }, {
    "PLZ": "37077",
    "Stadt": "Göttingen",
    "Förderung": "180 Euro pauschal pro Anlage",
    "Zusatzliche": "KlimaFonds der Stadt Göttingen"    
  }, {
    "PLZ": "37079",
    "Stadt": "Göttingen",
    "Förderung": "180 Euro pauschal pro Anlage",
    "Zusatzliche": "KlimaFonds der Stadt Göttingen"  
  }, {
    "PLZ": "37081",
    "Stadt": "Göttingen",
    "Förderung": "180 Euro pauschal pro Anlage",
    "Zusatzliche": "KlimaFonds der Stadt Göttingen"    
  }, {
    "PLZ": "37083",
    "Stadt": "Göttingen",
    "Förderung": "180 Euro pauschal pro Anlage",
    "Zusatzliche": "KlimaFonds der Stadt Göttingen"     
  }, {
    "PLZ": "37085",
    "Stadt": "Göttingen",
    "Förderung": "180 Euro pauschal pro Anlage",
    "Zusatzliche": "KlimaFonds der Stadt Göttingen"    
  }, {
    "PLZ": "37087",
    "Stadt": "Göttingen",
    "Förderung": "180 Euro pauschal pro Anlage",
    "Zusatzliche": "KlimaFonds der Stadt Göttingen"   
  }, {
    "PLZ": "37089",
    "Stadt": "Göttingen",
    "Förderung": "180 Euro pauschal pro Anlage",
    "Zusatzliche": "KlimaFonds der Stadt Göttingen"     
  }, {
    "PLZ": "37091",
    "Stadt": "Göttingen",
    "Förderung": "180 Euro pauschal pro Anlage",
    "Zusatzliche": "KlimaFonds der Stadt Göttingen"     
  }, {
    "PLZ": "37093",
    "Stadt": "Göttingen",
    "Förderung": "180 Euro pauschal pro Anlage",
    "Zusatzliche": "KlimaFonds der Stadt Göttingen"     
  }, {
    "PLZ": "37095",
    "Stadt": "Göttingen",
    "Förderung": "180 Euro pauschal pro Anlage",
    "Zusatzliche": "KlimaFonds der Stadt Göttingen"   
  }, {
    "PLZ": "37097",
    "Stadt": "Göttingen",
    "Förderung": "180 Euro pauschal pro Anlage",
    "Zusatzliche": "KlimaFonds der Stadt Göttingen"    
  }, {
    "PLZ": "37099",
    "Stadt": "Göttingen",
    "Förderung": "180 Euro pauschal pro Anlage",
    "Zusatzliche": "KlimaFonds der Stadt Göttingen"     
  }, {
    "PLZ": "26441",
    "Stadt": "Jever",
    "Förderung": "125 Euro pro Paneel (max. 2)",
    "Zusatzliche": "Jever Förderrichtlinien"    
  }, {
    "PLZ": "21335",
    "Stadt": "Lüneburg",
    "Förderung": "150 Euro + 30% der Investitionskosten pro Anlage",
    "Zusatzliche": ""    
  }, {
    "PLZ": "21337",
    "Stadt": "Lüneburg",
    "Förderung": "150 Euro + 30% der Investitionskosten pro Anlage",
    "Zusatzliche": ""    
  }, {
    "PLZ": "21339",
    "Stadt": "Lüneburg",
    "Förderung": "150 Euro + 30% der Investitionskosten pro Anlage",
    "Zusatzliche": ""    
  }, {
    "PLZ": "52062",
    "Stadt": "Aachen",
    "Förderung": "pauschal 300 Euro",
    "Zusatzliche": "Serviceportal der Stadt Aachen"    
  }, {
    "PLZ": "52064",
    "Stadt": "Aachen",
    "Förderung": "pauschal 300 Euro",
    "Zusatzliche": "Serviceportal der Stadt Aachen"   
  }, {
    "PLZ": "52066",
    "Stadt": "Aachen",
    "Förderung": "pauschal 300 Euro",
    "Zusatzliche": "Serviceportal der Stadt Aachen"  
  }, {
    "PLZ": "52068",
    "Stadt": "Aachen",
    "Förderung": "pauschal 300 Euro",
    "Zusatzliche": "Serviceportal der Stadt Aachen"   
  }, {
    "PLZ": "52070",
    "Stadt": "Aachen",
    "Förderung": "pauschal 300 Euro",
    "Zusatzliche": "Serviceportal der Stadt Aachen"   
  }, {
    "PLZ": "52072",
    "Stadt": "Aachen",
    "Förderung": "pauschal 300 Euro",
    "Zusatzliche": "Serviceportal der Stadt Aachen"  
  }, {
    "PLZ": "52074",
    "Stadt": "Aachen",
    "Förderung": "pauschal 300 Euro",
    "Zusatzliche": "Serviceportal der Stadt Aachen"
  }, {
    "PLZ": "52076",
    "Stadt": "Aachen",
    "Förderung": "pauschal 300 Euro",
    "Zusatzliche": "Serviceportal der Stadt Aachen"  
  }, {
    "PLZ": "52078",
    "Stadt": "Aachen",
    "Förderung": "pauschal 300 Euro",
    "Zusatzliche": "Serviceportal der Stadt Aachen"
  }, {
    "PLZ": "52080",
    "Stadt": "Aachen",
    "Förderung": "pauschal 300 Euro",
    "Zusatzliche": "Serviceportal der Stadt Aachen"  
  }, {
    "PLZ": "52062",
    "Stadt": "Aachen",
    "Förderung": "pauschal 300 Euro",
    "Zusatzliche": "Serviceportal der Stadt Aachen"  
  }, {
    "PLZ": "52064",
    "Stadt": "Aachen",
    "Förderung": "pauschal 300 Euro",
    "Zusatzliche": "Serviceportal der Stadt Aachen"  
  }, {
    "PLZ": "52066",
    "Stadt": "Aachen",
    "Förderung": "pauschal 300 Euro",
    "Zusatzliche": "Serviceportal der Stadt Aachen"   
  }, {
    "PLZ": "52068",
    "Stadt": "Aachen",
    "Förderung": "pauschal 300 Euro",
    "Zusatzliche": "Serviceportal der Stadt Aachen"
  }, {
    "PLZ": "52070",
    "Stadt": "Aachen",
    "Förderung": "pauschal 300 Euro",
    "Zusatzliche": "Serviceportal der Stadt Aachen"   
  }, {
    "PLZ": "52072",
    "Stadt": "Aachen",
    "Förderung": "pauschal 300 Euro",
    "Zusatzliche": "Serviceportal der Stadt Aachen" 
  }, {
    "PLZ": "52074",
    "Stadt": "Aachen",
    "Förderung": "pauschal 300 Euro",
    "Zusatzliche": "Serviceportal der Stadt Aachen"  
  }, {
    "PLZ": "52076",
    "Stadt": "Aachen",
    "Förderung": "pauschal 300 Euro",
    "Zusatzliche": "Serviceportal der Stadt Aachen"  
  }, {
    "PLZ": "52078",
    "Stadt": "Aachen",
    "Förderung": "pauschal 300 Euro",
    "Zusatzliche": "Serviceportal der Stadt Aachen"   
  }, {
    "PLZ": "52080",
    "Stadt": "Aachen",
    "Förderung": "pauschal 300 Euro",
    "Zusatzliche": "Serviceportal der Stadt Aachen"   
  }, {
    "PLZ": "48683",
    "Stadt": "Ahaus",
    "Förderung": "50% der förderfähigen Kosten bis 200 Euro",
    "Zusatzliche": "Ahaus Balkonsolar Förderrichtlinie"    
  }, {
    "PLZ": "53113",
    "Stadt": "Bonn",
    "Förderung": "Haus-/Wohnungs-Eigentümer, Erbbauberechtigte bis zu 300 Euro, Mieter bis zu 600 Euro. Bei Vorlage des Bonn-Ausweis: 90% der Kosten (max. 800 Euro)",
    "Zusatzliche": "Förderrichtlinie „Solares Bonn“"    
  }, {
    "PLZ": "53115",
    "Stadt": "Bonn",
    "Förderung": "Haus-/Wohnungs-Eigentümer, Erbbauberechtigte bis zu 300 Euro, Mieter bis zu 600 Euro. Bei Vorlage des Bonn-Ausweis: 90% der Kosten (max. 800 Euro)",
    "Zusatzliche": "Förderrichtlinie „Solares Bonn“"     
  }, {
    "PLZ": "53117",
    "Stadt": "Bonn",
    "Förderung": "Haus-/Wohnungs-Eigentümer, Erbbauberechtigte bis zu 300 Euro, Mieter bis zu 600 Euro. Bei Vorlage des Bonn-Ausweis: 90% der Kosten (max. 800 Euro)",
    "Zusatzliche": "Förderrichtlinie „Solares Bonn“"      
  }, {
    "PLZ": "53119",
    "Stadt": "Bonn",
    "Förderung": "Haus-/Wohnungs-Eigentümer, Erbbauberechtigte bis zu 300 Euro, Mieter bis zu 600 Euro. Bei Vorlage des Bonn-Ausweis: 90% der Kosten (max. 800 Euro)",
    "Zusatzliche": "Förderrichtlinie „Solares Bonn“"        
  }, {
    "PLZ": "53121",
    "Stadt": "Bonn",
    "Förderung": "Haus-/Wohnungs-Eigentümer, Erbbauberechtigte bis zu 300 Euro, Mieter bis zu 600 Euro. Bei Vorlage des Bonn-Ausweis: 90% der Kosten (max. 800 Euro)",
    "Zusatzliche": "Förderrichtlinie „Solares Bonn“"        
  }, {
    "PLZ": "53123",
    "Stadt": "Bonn",
    "Förderung": "Haus-/Wohnungs-Eigentümer, Erbbauberechtigte bis zu 300 Euro, Mieter bis zu 600 Euro. Bei Vorlage des Bonn-Ausweis: 90% der Kosten (max. 800 Euro)",
    "Zusatzliche": "Förderrichtlinie „Solares Bonn“"    
  }, {
    "PLZ": "53125",
    "Stadt": "Bonn",
    "Förderung": "Haus-/Wohnungs-Eigentümer, Erbbauberechtigte bis zu 300 Euro, Mieter bis zu 600 Euro. Bei Vorlage des Bonn-Ausweis: 90% der Kosten (max. 800 Euro)",
    "Zusatzliche": "Förderrichtlinie „Solares Bonn“"     
  }, {
    "PLZ": "53127",
    "Stadt": "Bonn",
    "Förderung": "Haus-/Wohnungs-Eigentümer, Erbbauberechtigte bis zu 300 Euro, Mieter bis zu 600 Euro. Bei Vorlage des Bonn-Ausweis: 90% der Kosten (max. 800 Euro)",
    "Zusatzliche": "Förderrichtlinie „Solares Bonn“"        
  }, {
    "PLZ": "53129",
    "Stadt": "Bonn",
    "Förderung": "Haus-/Wohnungs-Eigentümer, Erbbauberechtigte bis zu 300 Euro, Mieter bis zu 600 Euro. Bei Vorlage des Bonn-Ausweis: 90% der Kosten (max. 800 Euro)",
    "Zusatzliche": "Förderrichtlinie „Solares Bonn“"      
  }, {
    "PLZ": "53173",
    "Stadt": "Bonn",
    "Förderung": "Haus-/Wohnungs-Eigentümer, Erbbauberechtigte bis zu 300 Euro, Mieter bis zu 600 Euro. Bei Vorlage des Bonn-Ausweis: 90% der Kosten (max. 800 Euro)",
    "Zusatzliche": "Förderrichtlinie „Solares Bonn“"       
  }, {
    "PLZ": "53175",
    "Stadt": "Bonn",
    "Förderung": "Haus-/Wohnungs-Eigentümer, Erbbauberechtigte bis zu 300 Euro, Mieter bis zu 600 Euro. Bei Vorlage des Bonn-Ausweis: 90% der Kosten (max. 800 Euro)",
    "Zusatzliche": "Förderrichtlinie „Solares Bonn“"     
  }, {
    "PLZ": "53177",
    "Stadt": "Bonn",
    "Förderung": "Haus-/Wohnungs-Eigentümer, Erbbauberechtigte bis zu 300 Euro, Mieter bis zu 600 Euro. Bei Vorlage des Bonn-Ausweis: 90% der Kosten (max. 800 Euro)",
    "Zusatzliche": "Förderrichtlinie „Solares Bonn“"      
  }, {
    "PLZ": "53179",
    "Stadt": "Bonn",
    "Förderung": "Haus-/Wohnungs-Eigentümer, Erbbauberechtigte bis zu 300 Euro, Mieter bis zu 600 Euro. Bei Vorlage des Bonn-Ausweis: 90% der Kosten (max. 800 Euro)",
    "Zusatzliche": "Förderrichtlinie „Solares Bonn“"      
  }, {
    "PLZ": "53225",
    "Stadt": "Bonn",
    "Förderung": "Haus-/Wohnungs-Eigentümer, Erbbauberechtigte bis zu 300 Euro, Mieter bis zu 600 Euro. Bei Vorlage des Bonn-Ausweis: 90% der Kosten (max. 800 Euro)",
    "Zusatzliche": "Förderrichtlinie „Solares Bonn“"    
  }, {
    "PLZ": "53227",
    "Stadt": "Bonn",
    "Förderung": "Haus-/Wohnungs-Eigentümer, Erbbauberechtigte bis zu 300 Euro, Mieter bis zu 600 Euro. Bei Vorlage des Bonn-Ausweis: 90% der Kosten (max. 800 Euro)",
    "Zusatzliche": "Förderrichtlinie „Solares Bonn“"       
  }, {
    "PLZ": "53229",
    "Stadt": "Bonn",
    "Förderung": "Haus-/Wohnungs-Eigentümer, Erbbauberechtigte bis zu 300 Euro, Mieter bis zu 600 Euro. Bei Vorlage des Bonn-Ausweis: 90% der Kosten (max. 800 Euro)",
    "Zusatzliche": "Förderrichtlinie „Solares Bonn“"       
  }, {
    "PLZ": "53289",
    "Stadt": "Bonn",
    "Förderung": "Haus-/Wohnungs-Eigentümer, Erbbauberechtigte bis zu 300 Euro, Mieter bis zu 600 Euro. Bei Vorlage des Bonn-Ausweis: 90% der Kosten (max. 800 Euro)",
    "Zusatzliche": "Förderrichtlinie „Solares Bonn“"     
  }, {
    "PLZ": "53332",
    "Stadt": "Bonn",
    "Förderung": "Haus-/Wohnungs-Eigentümer, Erbbauberechtigte bis zu 300 Euro, Mieter bis zu 600 Euro. Bei Vorlage des Bonn-Ausweis: 90% der Kosten (max. 800 Euro)",
    "Zusatzliche": "Förderrichtlinie „Solares Bonn“"       
  }, {
    "PLZ": "34434",
    "Stadt": "Borgentreich",
    "Förderung": "pauschal 100 Euro l pro Haushalt",
    "Zusatzliche": "Förderprogramm „Stecker-Solar-Geräte“"    
  }, {
    "PLZ": "59199",
    "Stadt": "Bönen",
    "Förderung": "pauschal 100 Euro pro Wohneinheit",
    "Zusatzliche": "Bönen: Förderrichtlinie Balkonsolar"    
  }, {
    "PLZ": "44575",
    "Stadt": "Castrop-Rauxel",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "Balkonsolar Förderung Castrop-Rauxel"    
  }, {
    "PLZ": "44577",
    "Stadt": "Castrop-Rauxel",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "Balkonsolar Förderung Castrop-Rauxel"   
  }, {
    "PLZ": "44579",
    "Stadt": "Castrop-Rauxel",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "Balkonsolar Förderung Castrop-Rauxel"  
  }, {
    "PLZ": "44581",
    "Stadt": "Castrop-Rauxel",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "Balkonsolar Förderung Castrop-Rauxel"  
  }, {
    "PLZ": "40210",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"    
  }, {
    "PLZ": "40211",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"      
  }, {
    "PLZ": "40212",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"   
  }, {
    "PLZ": "40213",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"  
  }, {
    "PLZ": "40215",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"  
  }, {
    "PLZ": "40217",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"    
  }, {
    "PLZ": "40219",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"     
  }, {
    "PLZ": "40221",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"  
  }, {
    "PLZ": "40223",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"   
  }, {
    "PLZ": "40225",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"     
  }, {
    "PLZ": "40227",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"    
  }, {
    "PLZ": "40229",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"  
  }, {
    "PLZ": "40231",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"     
  }, {
    "PLZ": "40233",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"  
  }, {
    "PLZ": "40235",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"  
  }, {
    "PLZ": "40237",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"     
  }, {
    "PLZ": "40239",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"  
  }, {
    "PLZ": "40468",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"     
  }, {
    "PLZ": "40470",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"     
  }, {
    "PLZ": "40472",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"    
  }, {
    "PLZ": "40474",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"  
  }, {
    "PLZ": "40476",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"    
  }, {
    "PLZ": "40477",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"   
  }, {
    "PLZ": "40479",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"     
  }, {
    "PLZ": "40545",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"     
  }, {
    "PLZ": "40547",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"      
  }, {
    "PLZ": "40549",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"      
  }, {
    "PLZ": "40589",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"    
  }, {
    "PLZ": "40591",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"    
  }, {
    "PLZ": "40593",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"      
  }, {
    "PLZ": "40595",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"    
  }, {
    "PLZ": "40597",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"      
  }, {
    "PLZ": "40599",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"   
  }, {
    "PLZ": "40625",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"    
  }, {
    "PLZ": "40627",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"     
  }, {
    "PLZ": "40629",
    "Stadt": "Filderstadt",
    "Förderung": "150€ pro Haushalt",
    "Zusatzliche": "Filderstadt Balkonkraftwerk Förderwebseite"    
  }, {
    "PLZ": "40667",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"  
  }, {
    "PLZ": "40668",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"  
  }, {
    "PLZ": "40670",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"    
  }, {
    "PLZ": "40699",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"  
  }, {
    "PLZ": "40721",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"     
  }, {
    "PLZ": "40723",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"     
  }, {
    "PLZ": "40724",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"    
  }, {
    "PLZ": "40764",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"      
  }, {
    "PLZ": "40822",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"    
  }, {
    "PLZ": "40878",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"  
  }, {
    "PLZ": "40880",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"    
  }, {
    "PLZ": "40882",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"     
  }, {
    "PLZ": "40883",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"   
  }, {
    "PLZ": "40885",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"     
  }, {
    "PLZ": "41061",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"    
  }, {
    "PLZ": "41063",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"  
  }, {
    "PLZ": "41065",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"    
  }, {
    "PLZ": "41066",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"   
  }, {
    "PLZ": "41068",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"    
  }, {
    "PLZ": "41069",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"    
  }, {
    "PLZ": "41169",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"     
  }, {
    "PLZ": "41179",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"    
  }, {
    "PLZ": "41189",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"  
  }, {
    "PLZ": "41199",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"     
  }, {
    "PLZ": "41236",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"  
  }, {
    "PLZ": "41238",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"   
  }, {
    "PLZ": "41239",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"      
  }, {
    "PLZ": "41334",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"   
  }, {
    "PLZ": "41352",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"      
  }, {
    "PLZ": "41460",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"     
  }, {
    "PLZ": "41462",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"    
  }, {
    "PLZ": "41464",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"    
  }, {
    "PLZ": "41466",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"  
  }, {
    "PLZ": "41468",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"    
  }, {
    "PLZ": "41469",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"    
  }, {
    "PLZ": "41470",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"   
  }, {
    "PLZ": "41472",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"     
  }, {
    "PLZ": "41474",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"     
  }, {
    "PLZ": "41476",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"  
  }, {
    "PLZ": "41478",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"      
  }, {
    "PLZ": "41515",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"   
  }, {
    "PLZ": "41516",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"     
  }, {
    "PLZ": "41517",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"  
  }, {
    "PLZ": "41539",
    "Stadt": "Düsseldorf",
    "Förderung": "50% der förderfähigen Kosten, max. 400 Euro",
    "Zusatzliche": "Förderprogramm „Klimafreundliches Wohnen und Arbeiten in Düsseldorf“"    
  }, {
    "PLZ": "70794",
    "Stadt": "Filderstadt",
    "Förderung": "150€ pro Haushalt",
    "Zusatzliche": "Filderstadt Balkonkraftwerk Förderwebseite"    
  }, {
    "PLZ": "57258",
    "Stadt": "Freudenberg",
    "Förderung": "150 Euro je Balkonkraftwerk",
    "Zusatzliche": "reudenberg: Zuschussantrag"    
  }, {
    "PLZ": "58730",
    "Stadt": "Fröndenberg",
    "Förderung": "100 Euro pro Modul (max. 2)",
    "Zusatzliche": "Zuschussrichtlinie Fröndenberg"    
  }, {
    "PLZ": "45879",
    "Stadt": "Gelsenkirchen",
    "Förderung": "pauschal 150 Euro pro Wohneinheit",
    "Zusatzliche": "Gelsenkirchen Balkonkraftwerk Infoseite"    
  }, {
    "PLZ": "45881",
    "Stadt": "Gelsenkirchen",
    "Förderung": "pauschal 150 Euro pro Wohneinheit",
    "Zusatzliche": "Gelsenkirchen Balkonkraftwerk Infoseite"      
  }, {
    "PLZ": "45883",
    "Stadt": "Gelsenkirchen",
    "Förderung": "pauschal 150 Euro pro Wohneinheit",
    "Zusatzliche": "Gelsenkirchen Balkonkraftwerk Infoseite"       
  }, {
    "PLZ": "45884",
    "Stadt": "Gelsenkirchen",
    "Förderung": "pauschal 150 Euro pro Wohneinheit",
    "Zusatzliche": "Gelsenkirchen Balkonkraftwerk Infoseite"        
  }, {
    "PLZ": "45886",
    "Stadt": "Gelsenkirchen",
    "Förderung": "pauschal 150 Euro pro Wohneinheit",
    "Zusatzliche": "Gelsenkirchen Balkonkraftwerk Infoseite"       
  }, {
    "PLZ": "45888",
    "Stadt": "Gelsenkirchen",
    "Förderung": "pauschal 150 Euro pro Wohneinheit",
    "Zusatzliche": "Gelsenkirchen Balkonkraftwerk Infoseite"      
  }, {
    "PLZ": "45889",
    "Stadt": "Gelsenkirchen",
    "Förderung": "pauschal 150 Euro pro Wohneinheit",
    "Zusatzliche": "Gelsenkirchen Balkonkraftwerk Infoseite"    
  }, {
    "PLZ": "48599",
    "Stadt": "Gronau",
    "Förderung": "250 Euro pro Anlage, max. 60% der Anschaffungskosten",
    "Zusatzliche": "Gronau: Energiesparförderung 2023"    
  }, {
    "PLZ": "58553",
    "Stadt": "Halver",
    "Förderung": "100 Euro pro Haushalt",
    "Zusatzliche": "Balkonsolar Förderung in Halver"    
  }, {
    "PLZ": "59063",
    "Stadt": "Hamm",
    "Förderung": "pauschal 200 Euro pro Mini-Solaranlage",
    "Zusatzliche": "Klimaagentur Hamm Infoseite"    
  }, {
    "PLZ": "59065",
    "Stadt": "Hamm",
    "Förderung": "pauschal 200 Euro pro Mini-Solaranlage",
    "Zusatzliche": "Klimaagentur Hamm Infoseite"     
  }, {
    "PLZ": "59067",
    "Stadt": "Hamm",
    "Förderung": "pauschal 200 Euro pro Mini-Solaranlage",
    "Zusatzliche": "Klimaagentur Hamm Infoseite"      
  }, {
    "PLZ": "59069",
    "Stadt": "Hamm",
    "Förderung": "pauschal 200 Euro pro Mini-Solaranlage",
    "Zusatzliche": "Klimaagentur Hamm Infoseite"    
  }, {
    "PLZ": "59071",
    "Stadt": "Hamm",
    "Förderung": "pauschal 200 Euro pro Mini-Solaranlage",
    "Zusatzliche": "Klimaagentur Hamm Infoseite"     
  }, {
    "PLZ": "59073",
    "Stadt": "Hamm",
    "Förderung": "pauschal 200 Euro pro Mini-Solaranlage",
    "Zusatzliche": "Klimaagentur Hamm Infoseite"    
  }, {
    "PLZ": "59075",
    "Stadt": "Hamm",
    "Förderung": "pauschal 200 Euro pro Mini-Solaranlage",
    "Zusatzliche": "Klimaagentur Hamm Infoseite"      
  }, {
    "PLZ": "59077",
    "Stadt": "Hamm",
    "Förderung": "pauschal 200 Euro pro Mini-Solaranlage",
    "Zusatzliche": "Klimaagentur Hamm Infoseite"    
  }, {
    "PLZ": "59079",
    "Stadt": "Hamm",
    "Förderung": "pauschal 200 Euro pro Mini-Solaranlage",
    "Zusatzliche": "Klimaagentur Hamm Infoseite"    
  }, {
    "PLZ": "32120",
    "Stadt": "Hiddenhausen",
    "Förderung": "pauschal 150 Euro, mit Speicher 300 Euro",
    "Zusatzliche": "Förderprogramm „Spar mit Solar“"    
  }, {
    "PLZ": "47475",
    "Stadt": "Kamp-Lintfort",
    "Förderung": "100 Euro pro Wohnung",
    "Zusatzliche": "Kamp-Lintfort Zuschussübersicht"    
  }, {
    "PLZ": "32278",
    "Stadt": "Kirchlengern",
    "Förderung": "300 Euro pro Mini-Solaranlage",
    "Zusatzliche": "Richtlinie für die Förderung privater Photovoltaik-Kleinanlagen"    
  }, {
    "PLZ": "50667",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "50668",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "50670",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"       
  }, {
    "PLZ": "50672",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "50674",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"       
  }, {
    "PLZ": "50676",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"     
  }, {
    "PLZ": "50677",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "50678",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"     
  }, {
    "PLZ": "50679",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "50733",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "50735",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"     
  }, {
    "PLZ": "50737",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"   
  }, {
    "PLZ": "50739",
     "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "50765",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"     
  }, {
    "PLZ": "50767",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"    
  }, {
    "PLZ": "50769",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "50823",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"     
  }, {
    "PLZ": "50825",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "50827",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "50829",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"     
  }, {
    "PLZ": "50858",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"       
  }, {
    "PLZ": "50859",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "50931",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"       
  }, {
    "PLZ": "50933",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"       
  }, {
    "PLZ": "50935",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "50937",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "50939",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "50968",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"     
  }, {
    "PLZ": "50969",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "50996",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"     
  }, {
    "PLZ": "50997",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"    
  }, {
    "PLZ": "50999",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "51061",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"   
  }, {
    "PLZ": "51063",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"   
  }, {
    "PLZ": "51065",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"     
  }, {
    "PLZ": "51067",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"     
  }, {
    "PLZ": "51069",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"     
  }, {
    "PLZ": "51103",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"   
  }, {
    "PLZ": "51105",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"     
  }, {
    "PLZ": "51107",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "51109",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "51143",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "51145",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "51147",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"     
  }, {
    "PLZ": "51149",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"       
  }, {
    "PLZ": "51243",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"       
  }, {
    "PLZ": "51245",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"       
  }, {
    "PLZ": "51247",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"       
  }, {
    "PLZ": "51371",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "51373",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"     
  }, {
    "PLZ": "51375",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"     
  }, {
    "PLZ": "51377",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "51379",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "51427",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "51429",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "51465",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"     
  }, {
    "PLZ": "51467",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"    
  }, {
    "PLZ": "51469",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"    
  }, {
    "PLZ": "51503",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "51515",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"       
  }, {
    "PLZ": "51519",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"     
  }, {
    "PLZ": "51643",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"     
  }, {
    "PLZ": "51645",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "51647",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "51674",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "51688",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "51766",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"    
  }, {
    "PLZ": "51789",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"       
  }, {
    "PLZ": "52062",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"     
  }, {
    "PLZ": "52064",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"     
  }, {
    "PLZ": "52066",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "52068",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "52070",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "52072",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "52074",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "52076",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "52078",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"     
  }, {
    "PLZ": "52080",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"     
  }, {
    "PLZ": "52062",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "52064",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"   
  }, {
    "PLZ": "52066",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "52068",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"     
  }, {
    "PLZ": "52070",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"       
  }, {
    "PLZ": "52072",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"       
  }, {
    "PLZ": "52074",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"    
  }, {
    "PLZ": "52076",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "52078",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"      
  }, {
    "PLZ": "52080",
    "Stadt": "Köln",
    "Förderung": "200 Euro pro Balkonkraftwerk",
    "Zusatzliche": "Klimafreundliches Wohnen in Köln"    
  }, {
    "PLZ": "58507",
    "Stadt": "Lüdenscheid",
    "Förderung": "100 Euro pro Modul (max. 2)",
    "Zusatzliche": "Lüdenscheid Stecker-PV-Infoseite"  
  }, {
    "PLZ": "58509",
    "Stadt": "Lüdenscheid",
    "Förderung": "100 Euro pro Modul (max. 2)",
    "Zusatzliche": "Lüdenscheid Stecker-PV-Infoseite"    
  }, {
    "PLZ": "58511",
    "Stadt": "Lüdenscheid",
    "Förderung": "100 Euro pro Modul (max. 2)",
    "Zusatzliche": "Lüdenscheid Stecker-PV-Infoseite"    
  }, {
    "PLZ": "58513",
    "Stadt": "Lüdenscheid",
    "Förderung": "100 Euro pro Modul (max. 2)",
    "Zusatzliche": "Lüdenscheid Stecker-PV-Infoseite"     
  }, {
    "PLZ": "58515",
    "Stadt": "Lüdenscheid",
    "Förderung": "100 Euro pro Modul (max. 2)",
    "Zusatzliche": "Lüdenscheid Stecker-PV-Infoseite"    
  }, {
    "PLZ": "46045",
    "Stadt": "Oberhausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "FOberhausen PV Richtlinie"   
  }, {
    "PLZ": "46047",
    "Stadt": "Oberhausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "FOberhausen PV Richtlinie"   
  }, {
    "PLZ": "46049",
    "Stadt": "Oberhausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "FOberhausen PV Richtlinie"    
  }, {
    "PLZ": "46117",
    "Stadt": "Oberhausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "FOberhausen PV Richtlinie"    
  }, {
    "PLZ": "46119",
    "Stadt": "Oberhausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "FOberhausen PV Richtlinie"  
  }, {
    "PLZ": "46145",
     "Stadt": "Oberhausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "FOberhausen PV Richtlinie"   
  }, {
    "PLZ": "46147",
     "Stadt": "Oberhausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "FOberhausen PV Richtlinie"   
  }, {
    "PLZ": "46149",
    "Stadt": "Oberhausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "FOberhausen PV Richtlinie"  
  }, {
    "PLZ": "46236",
    "Stadt": "Oberhausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "FOberhausen PV Richtlinie"   
  }, {
    "PLZ": "46238",
    "Stadt": "Oberhausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "FOberhausen PV Richtlinie"   
  }, {
    "PLZ": "46240",
    "Stadt": "Oberhausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "FOberhausen PV Richtlinie"   
  }, {
    "PLZ": "46242",
    "Stadt": "Oberhausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "FOberhausen PV Richtlinie"  
  }, {
    "PLZ": "46244",
    "Stadt": "Oberhausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "FOberhausen PV Richtlinie" 
  }, {
    "PLZ": "46282",
    "Stadt": "Oberhausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "FOberhausen PV Richtlinie"    
  }, {
    "PLZ": "46284",
    "Stadt": "Oberhausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "FOberhausen PV Richtlinie"    
  }, {
    "PLZ": "46286",
    "Stadt": "Oberhausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "FOberhausen PV Richtlinie"   
  }, {
    "PLZ": "46288",
    "Stadt": "Oberhausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "FOberhausen PV Richtlinie"   
  }, {
    "PLZ": "46290",
    "Stadt": "Oberhausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "FOberhausen PV Richtlinie"    
  }, {
    "PLZ": "59939",
    "Stadt": "Olsberg",
    "Förderung": "pauschal 200 Euro pro Mini-PV Anlage",
    "Zusatzliche": "Olsberg PV-Förderungs-Richtlinie"    
  }, {
    "PLZ": "45657",
    "Stadt": "Recklinghausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "Recklingshausen: PV-Förderung"   
  }, {
    "PLZ": "45659",
    "Stadt": "Recklinghausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "Recklingshausen: PV-Förderung"    
  }, {
    "PLZ": "45661",
    "Stadt": "Recklinghausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "Recklingshausen: PV-Förderung"    
  }, {
    "PLZ": "45663",
    "Stadt": "Recklinghausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "Recklingshausen: PV-Förderung"    
  }, {
    "PLZ": "45665",
    "Stadt": "Recklinghausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "Recklingshausen: PV-Förderung"    
  }, {
    "PLZ": "45699",
    "Stadt": "Recklinghausen",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "Recklingshausen: PV-Förderung"    
  }, {
    "PLZ": "47495",
    "Stadt": "Rheinberg",
    "Förderung": "pauschal 100 Euro je Wohnung (nicht mehr verfügbar)",
    "Zusatzliche": "Rheinberg: Balkonkraftwerk-Förderung"    
  }, {
    "PLZ": "51427",
    "Stadt": "Rheinisch-Bergischer-Kreis",
    "Förderung": "10% der zuwendungsfähigen Ausgaben",
    "Zusatzliche": "Infoseite zur Solaranlagen Förderung"     
  }, {
    "PLZ": "51429",
    "Stadt": "Rheinisch-Bergischer-Kreis",
    "Förderung": "10% der zuwendungsfähigen Ausgaben",
    "Zusatzliche": "Infoseite zur Solaranlagen Förderung"    
  }, {
    "PLZ": "51465",
    "Stadt": "Rheinisch-Bergischer-Kreis",
    "Förderung": "10% der zuwendungsfähigen Ausgaben",
    "Zusatzliche": "Infoseite zur Solaranlagen Förderung"     
  }, {
    "PLZ": "51467",
    "Stadt": "Rheinisch-Bergischer-Kreis",
    "Förderung": "10% der zuwendungsfähigen Ausgaben",
    "Zusatzliche": "Infoseite zur Solaranlagen Förderung"    
  }, {
    "PLZ": "51469",
    "Stadt": "Rheinisch-Bergischer-Kreis",
    "Förderung": "10% der zuwendungsfähigen Ausgaben",
    "Zusatzliche": "Infoseite zur Solaranlagen Förderung"  
  }, {
    "PLZ": "51503",
    "Stadt": "Rheinisch-Bergischer-Kreis",
    "Förderung": "10% der zuwendungsfähigen Ausgaben",
    "Zusatzliche": "Infoseite zur Solaranlagen Förderung"    
  }, {
    "PLZ": "51515",
    "Stadt": "Rheinisch-Bergischer-Kreis",
    "Förderung": "10% der zuwendungsfähigen Ausgaben",
    "Zusatzliche": "Infoseite zur Solaranlagen Förderung"    
  }, {
    "PLZ": "51519",
    "Stadt": "Rheinisch-Bergischer-Kreis",
    "Förderung": "10% der zuwendungsfähigen Ausgaben",
    "Zusatzliche": "Infoseite zur Solaranlagen Förderung"    
  }, {
    "PLZ": "46562",
    "Stadt": "Voerde am Niederrhein",
    "Förderung": "pauschal 100 Euro je Wohnung",
    "Zusatzliche": "Klimaschutz Infoseite der Solarmetropole Ruhr"    
  }, {
    "PLZ": "46483",
    "Stadt": "Wesel",
    "Förderung": "50% der Kosten, max. 200 Euro",
    "Zusatzliche": "Stecker-PV-Anlagen Zuschuss Richtlinie"   
  }, {
    "PLZ": "46485",
    "Stadt": "Wesel",
    "Förderung": "50% der Kosten, max. 200 Euro",
    "Zusatzliche": "Stecker-PV-Anlagen Zuschuss Richtlinie"    
  }, {
    "PLZ": "46487",
    "Stadt": "Wesel",
    "Förderung": "50% der Kosten, max. 200 Euro",
    "Zusatzliche": "Stecker-PV-Anlagen Zuschuss Richtlinie"   
  }, {
    "PLZ": "46499",
    "Stadt": "Wesel",
    "Förderung": "50% der Kosten, max. 200 Euro",
    "Zusatzliche": "Stecker-PV-Anlagen Zuschuss Richtlinie"    
  }, {
    "PLZ": "58739",
    "Stadt": "Wickede (Ruhr)",
    "Förderung": "pauschal 150 Euro pro Mini-PV-Anlage, 300 Euro pro Anlage mit Speicher",
    "Zusatzliche": ""    
  }, {
    "PLZ": "56068",
    "Stadt": "Koblenz",
    "Förderung": "70 Euro pro Modul (max. 2)",
    "Zusatzliche": "Richtlinie zum 500-Dächer-Programm der Stadt Koblenz"      
  }, {
    "PLZ": "56070",
    "Stadt": "Koblenz",
    "Förderung": "70 Euro pro Modul (max. 2)",
    "Zusatzliche": "Richtlinie zum 500-Dächer-Programm der Stadt Koblenz"     
  }, {
    "PLZ": "56072",
    "Stadt": "Koblenz",
    "Förderung": "70 Euro pro Modul (max. 2)",
    "Zusatzliche": "Richtlinie zum 500-Dächer-Programm der Stadt Koblenz"     
  }, {
    "PLZ": "56073",
    "Stadt": "Koblenz",
    "Förderung": "70 Euro pro Modul (max. 2)",
    "Zusatzliche": "Richtlinie zum 500-Dächer-Programm der Stadt Koblenz"      
  }, {
    "PLZ": "56075",
    "Stadt": "Koblenz",
    "Förderung": "70 Euro pro Modul (max. 2)",
    "Zusatzliche": "Richtlinie zum 500-Dächer-Programm der Stadt Koblenz"     
  }, {
    "PLZ": "56076",
    "Stadt": "Koblenz",
    "Förderung": "70 Euro pro Modul (max. 2)",
    "Zusatzliche": "Richtlinie zum 500-Dächer-Programm der Stadt Koblenz"     
  }, {
    "PLZ": "56077",
    "Stadt": "Koblenz",
    "Förderung": "70 Euro pro Modul (max. 2)",
    "Zusatzliche": "Richtlinie zum 500-Dächer-Programm der Stadt Koblenz"    
  }, {
    "PLZ": "66953",
    "Stadt": "Pirmasens",
    "Förderung": "75 Euro Zuschuss für die Anschlusskosten von Mini-Solaranlagen bis max. 325 Watt durch einen Fachmann (150 Euro für Anlagen bis 600 Watt)t",
    "Zusatzliche": "Richtlinie der Stadtwerke Pirmasens zur Förderung der Balkonkraftwerk Installation"  
  }, {
    "PLZ": "66954",
    "Stadt": "Pirmasens",
    "Förderung": "75 Euro Zuschuss für die Anschlusskosten von Mini-Solaranlagen bis max. 325 Watt durch einen Fachmann (150 Euro für Anlagen bis 600 Watt)t",
    "Zusatzliche": "Richtlinie der Stadtwerke Pirmasens zur Förderung der Balkonkraftwerk Installation"    
  }, {
    "PLZ": "66955",
    "Stadt": "Pirmasens",
    "Förderung": "75 Euro Zuschuss für die Anschlusskosten von Mini-Solaranlagen bis max. 325 Watt durch einen Fachmann (150 Euro für Anlagen bis 600 Watt)t",
    "Zusatzliche": "Richtlinie der Stadtwerke Pirmasens zur Förderung der Balkonkraftwerk Installation"   
  }, {
    "PLZ": "66956",
    "Stadt": "Pirmasens",
    "Förderung": "75 Euro Zuschuss für die Anschlusskosten von Mini-Solaranlagen bis max. 325 Watt durch einen Fachmann (150 Euro für Anlagen bis 600 Watt)t",
    "Zusatzliche": "Richtlinie der Stadtwerke Pirmasens zur Förderung der Balkonkraftwerk Installation" 
  }, {
    "PLZ": "66969",
    "Stadt": "Pirmasens",
    "Förderung": "75 Euro Zuschuss für die Anschlusskosten von Mini-Solaranlagen bis max. 325 Watt durch einen Fachmann (150 Euro für Anlagen bis 600 Watt)t",
    "Zusatzliche": "Richtlinie der Stadtwerke Pirmasens zur Förderung der Balkonkraftwerk Installation"    
  }, {
    "PLZ": "56220",
    "Stadt": "Urmitz",
    "Förderung": "pauschal 100 Euro pro Haushaltt",
    "Zusatzliche": ""    
  }, {
    "PLZ": "24534",
    "Stadt": "Schleswig-Holstein",
    "Förderung": "bis zu 200 Euro pro Haushalt (jedoch nur max. 50%)",
    "Zusatzliche": "Richtlinie zur Förderung von Photovoltaik-Balkonanlagen"   
  }, {
    "PLZ": "24536",
    "Stadt": "Schleswig-Holstein",
    "Förderung": "bis zu 200 Euro pro Haushalt (jedoch nur max. 50%)",
    "Zusatzliche": "Richtlinie zur Förderung von Photovoltaik-Balkonanlagen"     
  }, {
    "PLZ": "24537",
    "Stadt": "Schleswig-Holstein",
    "Förderung": "bis zu 200 Euro pro Haushalt (jedoch nur max. 50%)",
    "Zusatzliche": "Richtlinie zur Förderung von Photovoltaik-Balkonanlagen"  
  }, {
    "PLZ": "24539",
    "Stadt": "Schleswig-Holstein",
    "Förderung": "bis zu 200 Euro pro Haushalt (jedoch nur max. 50%)",
    "Zusatzliche": "Richtlinie zur Förderung von Photovoltaik-Balkonanlagen"    
  }, {
    "PLZ": "24103",
    "Stadt": "Kiel",
    "Förderung": "pauschal 100 Euro pro Mini-Solaranlage",
    "Zusatzliche": "Förderrichtlinie Photovoltaik und Solarthermieanlagen"    
  }, {
    "PLZ": "24105",
    "Stadt": "Kiel",
    "Förderung": "pauschal 100 Euro pro Mini-Solaranlage",
    "Zusatzliche": "Förderrichtlinie Photovoltaik und Solarthermieanlagen"     
  }, {
    "PLZ": "24106",
    "Stadt": "Kiel",
    "Förderung": "pauschal 100 Euro pro Mini-Solaranlage",
    "Zusatzliche": "Förderrichtlinie Photovoltaik und Solarthermieanlagen"     
  }, {
    "PLZ": "24107",
    "Stadt": "Kiel",
    "Förderung": "pauschal 100 Euro pro Mini-Solaranlage",
    "Zusatzliche": "Förderrichtlinie Photovoltaik und Solarthermieanlagen"     
  }, {
    "PLZ": "24109",
    "Stadt": "Kiel",
    "Förderung": "pauschal 100 Euro pro Mini-Solaranlage",
    "Zusatzliche": "Förderrichtlinie Photovoltaik und Solarthermieanlagen"     
  }, {
    "PLZ": "24111",
    "Stadt": "Kiel",
    "Förderung": "pauschal 100 Euro pro Mini-Solaranlage",
    "Zusatzliche": "Förderrichtlinie Photovoltaik und Solarthermieanlagen"     
  }, {
    "PLZ": "24113",
    "Stadt": "Kiel",
    "Förderung": "pauschal 100 Euro pro Mini-Solaranlage",
    "Zusatzliche": "Förderrichtlinie Photovoltaik und Solarthermieanlagen"    
  }, {
    "PLZ": "24114",
    "Stadt": "Kiel",
    "Förderung": "pauschal 100 Euro pro Mini-Solaranlage",
    "Zusatzliche": "Förderrichtlinie Photovoltaik und Solarthermieanlagen"     
  }, {
    "PLZ": "24116",
    "Stadt": "Kiel",
    "Förderung": "pauschal 100 Euro pro Mini-Solaranlage",
    "Zusatzliche": "Förderrichtlinie Photovoltaik und Solarthermieanlagen"     
  }, {
    "PLZ": "24118",
    "Stadt": "Kiel",
    "Förderung": "pauschal 100 Euro pro Mini-Solaranlage",
    "Zusatzliche": "Förderrichtlinie Photovoltaik und Solarthermieanlagen"    
  }, {
    "PLZ": "23552",
    "Stadt": "Lübeck",
    "Förderung": "pauschal 200 Euro pro Haushalt",
    "Zusatzliche": ""    
  }, {
    "PLZ": "23554",
    "Stadt": "Lübeck",
    "Förderung": "pauschal 200 Euro pro Haushalt",
    "Zusatzliche": ""   
  }, {
    "PLZ": "23556",
    "Stadt": "Lübeck",
    "Förderung": "pauschal 200 Euro pro Haushalt",
    "Zusatzliche": ""    
  }, {
    "PLZ": "23558",
    "Stadt": "Lübeck",
    "Förderung": "pauschal 200 Euro pro Haushalt",
    "Zusatzliche": "" 
  }, {
    "PLZ": "23560",
    "Stadt": "Lübeck",
    "Förderung": "pauschal 200 Euro pro Haushalt",
    "Zusatzliche": ""   
  }, {
    "PLZ": "23562",
    "Stadt": "Lübeck",
    "Förderung": "pauschal 200 Euro pro Haushalt",
    "Zusatzliche": "" 
  }, {
    "PLZ": "23564",
    "Stadt": "Lübeck",
    "Förderung": "pauschal 200 Euro pro Haushalt",
    "Zusatzliche": ""    
  }, {
    "PLZ": "23566",
    "Stadt": "Lübeck",
    "Förderung": "pauschal 200 Euro pro Haushalt",
    "Zusatzliche": ""    
  }, {
    "PLZ": "23568",
    "Stadt": "Lübeck",
    "Förderung": "pauschal 200 Euro pro Haushalt",
    "Zusatzliche": ""    
  }, {
    "PLZ": "23569",
    "Stadt": "Lübeck",
    "Förderung": "pauschal 200 Euro pro Haushalt",
    "Zusatzliche": ""   
  }, {
    "PLZ": "23570",
    "Stadt": "Lübeck",
    "Förderung": "pauschal 200 Euro pro Haushalt",
    "Zusatzliche": ""    
  }, {
    "PLZ": "23588",
    "Stadt": "Lübeck",
    "Förderung": "pauschal 200 Euro pro Haushalt",
    "Zusatzliche": ""   
  }, {
    "PLZ": "23589",
    "Stadt": "Lübeck",
    "Förderung": "pauschal 200 Euro pro Haushalt",
    "Zusatzliche": ""    
  }, {
    "PLZ": "44575",
    "Stadt": "Castrop Rauxel",
    "Förderung": "100 € (12 % gespart)",
    "Zusatzliche": "vor Kauf"        
  }, {
    "PLZ": "44577",
    "Stadt": "Castrop Rauxel",
    "Förderung": "100 € (12 % gespart)",
    "Zusatzliche": "vor Kauf"      
  }, {
    "PLZ": "44579",
    "Stadt": "Castrop Rauxel",
    "Förderung": "100 € (12 % gespart)",
    "Zusatzliche": "vor Kauf"       
  }, {
    "PLZ": "44581",
    "Stadt": "Castrop Rauxel",
    "Förderung": "100 € (12 % gespart)",
    "Zusatzliche": "vor Kauf"    
  }, {
    "PLZ": "86911",
    "Stadt": "Dießen",
    "Förderung": "100 € (12 % gespart)",
    "Zusatzliche": "vor Kauf"    
  }, {
    "PLZ": "65760",
    "Stadt": "Eschborn",
    "Förderung": "400 € (48 % gespart)",
    "Zusatzliche": "vor Kauf"    
  }, {
    "PLZ": "35633",
    "Stadt": "Lahnau",
    "Förderung": "200 € (24 % gespart)",
    "Zusatzliche": "vor Kauf"    
  }, {
    "PLZ": "68623",
    "Stadt": "Lampertheim",
    "Förderung": "497 € (60 % gespart)",
    "Zusatzliche": "vor Kauf"    
  }, {
    "PLZ": "76316",
    "Stadt": "Malsch",
    "Förderung": "50 € (6 % gespart)",
    "Zusatzliche": "vor Kauf"    
  }, {
    "PLZ": "85368",
    "Stadt": "Moosburg an der Isar",
    "Förderung": "200 € (24 % gespart)",
    "Zusatzliche": "nach Kauf"    
  }, {
    "PLZ": "64546",
    "Stadt": "Mörfelden- Walldorf",
    "Förderung": "200 € (24 % gespart)",
    "Zusatzliche": "nach Kauf"    
  }, {
    "PLZ": "71409",
    "Stadt": "Schwaikheim",
    "Förderung": "200 € (24 % gespart)",
    "Zusatzliche": "vor Kauf/nach Kauf"    
  }, {
    "PLZ": "85716",
    "Stadt": "Unterschließheim",
    "Förderung": "200 € (24 % gespart)",
    "Zusatzliche": "nach Kauf"    
  }, {
    "PLZ": "91080",
    "Stadt": "Uttenreuth",
    "Förderung": "200 € (24 % gespart)",
    "Zusatzliche": "vor Kauf"    
  }, {
    "PLZ": "46562",
    "Stadt": "Vörde",
    "Förderung": "100 € (12 % gespart)",
    "Zusatzliche": "vor Kauf"    
  }, {
    "PLZ": "82362",
    "Stadt": "Weilheim in OB",
    "Förderung": "207 € (25 % gespart)",
    "Zusatzliche": "vor Kauf"    
  }]
}
  $(".balkonkraftwerk-btn").click(function(){
    var found = false;
    var Complete_html = "";
  var digit =  $(".balkonkraftwerk-input input").val();
var name = [digit];

  $.grep(data.items, function(v) {
  if(name.indexOf(v.PLZ) > -1)
  {
    var desc = (v.Zusatzliche);
    var city = (v.Stadt);
    var price = (v.Förderung);
    found = true;
    $(".balkonkraftwerk-munchen h5").html(city);
    $(".balkonkraftwerk-amount h4").html(price);
     $(".balkonkraftwerk-munchen p").html(desc);
  }
    });
    if(found==true){
      $(".not-match").hide();
      $(".balkonkraftwerk-munchen").show();
      $(".balkonkraftwerk-amount").show();
    }
    else{
      $(".not-match").show();
      $(".balkonkraftwerk-munchen").hide();
      $(".balkonkraftwerk-amount").hide();      
    }
   
});

})